import { ChangeDetectionStrategy, Component, inject, input, TemplateRef } from "@angular/core";

import { ILocationType, IRecordResponse } from "src/app/shared/interfaces";

import { ItemsSupplyChainModel } from "@components/shared/items-supply-chain/items-supply-chain.component.model";
import { TextConstants } from "@shared/constants";
import { FeatureFlagEnum } from "@shared/enums";
import { FeatureFlagService } from "@shared/services";

@Component({
  standalone: false,
  selector: "app-flow-chart-node",
  templateUrl: "./flow-chart-node.component.html",
  styleUrls: ["./flow-chart-node.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlowChartNodeComponent {
  public isSafari = input<boolean>(false);

  public location = input<any>(undefined);

  public canRemove = input<boolean>(false);

  public isEditing = input<boolean>(false);

  public hasAvailableDocuments = input<boolean>(false);

  public hasAvailableCertificates = input<boolean>(false);

  public delivery = input<any>(undefined);

  public groupedProduct = input<ItemsSupplyChainModel.IGroupedProduct>(undefined);

  public deliveriesRulesetsRecords = input<IRecordResponse[]>([]);

  public locationsRulesetsRecords = input<IRecordResponse[]>([]);

  public template = input<TemplateRef<any>>(undefined);

  public class = input<string>("");

  public shouldOpenInNewTab = input<boolean>(false);

  private readonly featureFlagService = inject(FeatureFlagService);

  public readonly isSupplyChainShowOrgDocsAndCertsEnabled = this.featureFlagService.isEnabled(
    FeatureFlagEnum.SUPPLY_CHAIN_SHOW_ORG_DOCS_AND_CERTS,
  );

  public readonly translations: any = {
    removeTp: TextConstants.REMOVE,
  };

  get locationTypes(): ILocationType[] {
    return this.location().types.slice(0, 8);
  }
}
